import React, { useEffect, useRef, useState } from 'react';

export default function SectionReveal({ children, className = '', delay = 0 }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setVisible(true); obs.disconnect(); } },
      { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <div ref={ref} className={className}>
      {/* Premium divider line that expands from center.
          `wh-ayrac` sınıfı, çizginin alt boşluğunu CSS'ten yönetebilmek için
          eklendi; eskiden burada satır içi `marginBottom: '0px'` vardı ve
          satır içi stil sınıf kuralını yendiği için çizgi hep altındaki
          içeriğe yapışık kalıyordu. 0 zaten varsayılan olduğundan satırın
          kaldırılması, kendi dolgusu olan bölümlerde (Products, HowItWorks,
          Features, Security, SSS) hiçbir şeyi değiştirmez. Boşluğu yalnızca
          kendi dolgusu OLMAYAN `.wh-urun-bolum` sarmalayıcısı verir. */}
      <div
        className="wh-ayrac mx-auto overflow-hidden"
        style={{
          width: '100%',
          maxWidth: '200px',
          height: '1px',
          background: 'linear-gradient(90deg, transparent, rgba(6, 182, 212, 0.4), rgba(139, 92, 246, 0.4), transparent)',
          transform: visible ? 'scaleX(1)' : 'scaleX(0)',
          transition: `transform 1s cubic-bezier(0.16, 1, 0.3, 1) ${delay}ms`,
          willChange: 'transform',
        }}
      />
      {/* Content with fade + slide up */}
      <div
        style={{
          opacity: visible ? 1 : 0,
          transform: visible ? 'translateY(0) scale(1)' : 'translateY(50px) scale(0.98)',
          transition: `opacity 0.9s cubic-bezier(0.16, 1, 0.3, 1) ${delay + 150}ms, transform 0.9s cubic-bezier(0.16, 1, 0.3, 1) ${delay + 150}ms`,
          willChange: 'opacity, transform',
        }}
      >
        {children}
      </div>
    </div>
  );
}
